import React from 'react';
import OneLinerContainer from 'molecules/OneLinerContainer/OneLinerContainer';

const TestimonialOneLinerContainer = (): JSX.Element => (
  <OneLinerContainer
    variant={4}
    text={{
      text: 'A parenting community used Community Design™ to grow from 0 to 102,000 members in 2 years and $5M+ in revenue.',
    }}
  />
);

export default TestimonialOneLinerContainer;
